import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import RelaxModel from "Base/model/RelaxModel";

export default class MinimalRollingState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    start() {
        super.start();
        let delay = (EntryPoint.GameSettings.quickSpin && RelaxModel.availableFastSpin) ? 500 : RelaxModel.spinTime;
        this.timeout = setTimeout(()=>{
            this.complete();
        }, delay);
    }

    onEnd() {
        super.onEnd();
        clearTimeout(this.timeout);
    }
}